import React from "react";
import { CruiseProvider } from "../context/CruiseContext";
import europe from "../data/europe";
import SiteLayout from "../components/SiteLayout";

const Europe = () => (
  <CruiseProvider cruise={europe}>
    <SiteLayout />
  </CruiseProvider>
);

export default Europe;
